import React, { FunctionComponent } from 'react';
import LoaderDotsIcon from '../../../icons/components/LoaderDots';

import { Text } from '../Text';

export const Loader: FunctionComponent<{ isLoading: { state: boolean, message: string } }> = ({ isLoading }) => {
    return (
        <div className={`c-loader ${isLoading.state ? 'loader--is-loading' : ''}`}>
            <div className="loader__modal">
								<Text as="h2">{isLoading.message}</Text>
                <LoaderDotsIcon width={100} height={100} />
            </div>
        </div>
    );
};
